export const formatDate = (dt) => {
  if (!dt) return "-";
  const d = new Date(dt);
  if (isNaN(d.getTime())) return dt;
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const formatTime = (dt) => {
  if (!dt) return "-";
  if (String(dt).includes("T00:00:00")) return "-";
  const d = new Date(String(dt).replace(/Z$/, ''));
  if (isNaN(d.getTime())) return dt;
  return d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });
};

export const formatDateTime = (dt) => {
  if (!dt) return "-";
  const d = new Date(String(dt).replace(/Z$/, ''));
  if (isNaN(d.getTime())) return dt;
  return d.toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true,
  });
};

// For DD/MM/YYYY HH:MM:SS AM/PM format (lab history API)
export const formatHistoryDate = (dt) => {
  if (!dt) return "-";
  const s = String(dt).trim();
  if (/^\d{1,2}\/\d{1,2}\/\d{4}/.test(s)) {
    const [datePart, ...rest] = s.split(' ');
    const [day, month, year] = datePart.split('/');
    const iso = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    const d = new Date(rest.length ? `${iso} ${rest.join(' ')}` : iso);
    if (isNaN(d.getTime())) return dt;
    return d.toLocaleString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true,
    });
  }
  return dt;
};
